const BeforeAfterHighlightLegend = () => {
    return (
        <>
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: '#1E1E1E',
                padding: '10px',
                borderRadius: '8px',
                marginBottom: '10px'
            }}>
                <div style={{ display: 'flex', alignItems: 'center', marginRight: '15px' }}>
                    <div style={{
                        width: '20px',
                        height: '20px',
                        backgroundColor: '#67ea04', // Green for beforeSubcatchment
                        marginRight: '5px',
                        borderRadius: '4px'
                    }}></div>
                    <span style={{ color: '#ffffff' }}>Before</span>
                </div>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <div style={{
                        width: '20px',
                        height: '20px',
                        backgroundColor: '#0477ea', // Blue for afterSubcatchment
                        marginRight: '5px',
                        borderRadius: '4px'
                    }}></div>
                    <span style={{ color: '#ffffff' }}>After</span>
                </div>
            </div>
        </>
    )
}

export default BeforeAfterHighlightLegend;